export default {
  /**
   * Write to local storage
   * @param data Could be any value, that can be JSON stringified
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#description
   * @param name key to save data in local storage
   */
  storeUserSettings<Data>(data: Data, name: string): void {
    if (storageAvailable('localStorage')) {
      localStorage.setItem(name, JSON.stringify(data));
    }
  },

  /**
   * Write from local storage
   * @param name key to read data from local storage
   * @returns returns read data, could be null if not found in local storage
   */
  retrieveUserSettings<Data>(name: string): Data {
    if (storageAvailable('localStorage')) {
      const settings = localStorage.getItem(name);
      return JSON.parse(settings);
    }
    return null;
  },
};

// eslint-disable-next-line complexity
function storageAvailable(type: 'localStorage'): boolean {
  let storage;
  try {
    storage = window[type];
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage &&
      storage.length !== 0
    );
  }
}
